import moment from "moment";
import { Grid, Label, Loader } from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";

const ExecutedOrderItem = ({ item }) => (
  <Grid gap="25px" templateColumns={{ medium: "1fr 1fr 1fr" }}>
    <Grid>
      <Label>{strings.executionStartedAt}</Label>
      <span className="text-muted">
        {item.executionStartedAt
          ? moment(item.executionStartedAt).format("YYYY-MM-DD HH:mm:ss")
          : "N/A"}
      </span>
    </Grid>
    <Grid>
      <Label>{strings.executionEndedAt}</Label>
      <span className="text-muted">
        {item.executionEndedAt
          ? moment(item.executionEndedAt).format("YYYY-MM-DD HH:mm:ss")
          : "N/A"}
      </span>
    </Grid>
    <Grid>
      <Label>{strings.userExecutor}</Label>
      <span className="text-muted">
        {item.hasOwnProperty("userExecutorName") ? (
          item.userExecutorName
        ) : (
          <Loader />
        )}
      </span>
    </Grid>
    <Grid>
      <Label>{strings.observations}</Label>
      <span className="text-muted">{item.observations}</span>
    </Grid>
  </Grid>
);

const strings = new LocalizedStrings({
  es: {
    executedAt: "Fecha de Ejecución",
    executionStartedAt: "Fecha Inicio de Ejecución",
    executionEndedAt: "Fecha Final de Ejecución",
    userExecutor: "Ejecutor",
    observations: "Observaciones",
  },
});

export default ExecutedOrderItem;
